import React from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { FormikProps } from 'formik';
import { PAYMENT_METHOD_OPTIONS } from '../../utils/paymentMethods';

type MethodValues = { method: string; referenceNumber: string };

/**
 * How money moved and its reference, as two half-width grid cells. The
 * method decides the cash or bank account the books record it in.
 */
function PaymentMethodFields<T extends MethodValues>({ formik, label = 'Method' }: { formik: FormikProps<T>; label?: string }) {
  return (
    <>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControl fullWidth error={!!formik.touched.method && !!formik.errors.method}>
          <InputLabel>{label} *</InputLabel>
          <Select name="method" value={formik.values.method} onChange={formik.handleChange} label={`${label} *`}>
            {PAYMENT_METHOD_OPTIONS.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          name="referenceNumber"
          label="Reference number"
          placeholder="Bank ref, cheque no., txn id"
          value={formik.values.referenceNumber}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={!!formik.touched.referenceNumber && !!formik.errors.referenceNumber}
          helperText={formik.touched.referenceNumber && (formik.errors.referenceNumber as string)}
        />
      </Grid>
    </>
  );
}

export default PaymentMethodFields;
